module.exports = __webpack_public_path__ + "static/media/Gasplant - sea.6e6b1f56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Gasplant - sea.svg
// module id = 188
// module chunks = 0